import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchAddClient } from '../services/patchAddClient.service';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const addProjectOrganizationChartClientForBusiness = createAsyncThunk(
  'organizationCharts/addProjectOrganizationChartClientForBusiness',
  async (
    {
      targetOrganizationChartItemId,
      clientBusinessId,
      clientBusinessName,
      clientOrganizationChartItemId,
      existingBusinessActionType,
    },
    { getState }
  ) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const response = await patchAddClient({
      projectId: selectedProjectId,
      targetOrganizationChartItemId,
      clientBusinessId,
      clientBusinessName,
      activeEmployerInfo,
      clientOrganizationChartItemId,
      existingBusinessActionType,
    });

    return response;
  }
);
